import { Box, Card, SimpleGrid, Skeleton, Stat, Text } from "@chakra-ui/react";
import { Clock, Wallet } from "lucide-react";
import { useFetchBalance } from "../hooks/useFetchBalance";

export default function BalanceCards() {
  const { balance, isLoading } = useFetchBalance();

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <SimpleGrid data-tour="page-summary" columns={{ base: 1, md: 2 }} gap={4}>
      <Card.Root
        size="sm"
        variant="elevated"
        bg="palomma.500"
        color="white"
        borderRadius="lg"
        boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
      >
        <Card.Body p={3}>
          <Box display="flex" alignItems="center" gap={3}>
            <Box bg="whiteAlpha.200" p={2} borderRadius="full" flexShrink={0}>
              <Wallet size={18} color="white" />
            </Box>
            <Stat.Root flex={1} minW={0}>
              <Box
                display="flex"
                alignItems="baseline"
                flexWrap="wrap"
                gap={{ base: 0, sm: 2 }}
              >
                <Text
                  fontWeight="medium"
                  fontSize="sm"
                  color="whiteAlpha.800"
                  order={{ base: 0, sm: 1 }}
                  flexBasis={{ base: "100%", sm: "auto" }}
                >
                  Disponible
                </Text>
                {isLoading ? (
                  <Skeleton height="28px" width="96px" bg="whiteAlpha.300" />
                ) : (
                  <Stat.ValueText
                    fontSize={{ base: "xl", sm: "2xl" }}
                    fontWeight="bold"
                    letterSpacing="tight"
                  >
                    {balance ? formatCurrency(balance.available) : "$0"}
                  </Stat.ValueText>
                )}
              </Box>
              <Stat.HelpText color="whiteAlpha.800" mt={0} fontSize="xs">
                Disponible para retiros o transferencias
              </Stat.HelpText>
            </Stat.Root>
          </Box>
        </Card.Body>
      </Card.Root>

      <Card.Root
        size="sm"
        variant="elevated"
        bg="white"
        borderRadius="lg"
        boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
      >
        <Card.Body p={3}>
          <Box display="flex" alignItems="center" gap={3}>
            <Box bg="gray.100" p={2} borderRadius="full" flexShrink={0}>
              <Clock size={18} color="#a0aec0" />
            </Box>
            <Stat.Root flex={1} minW={0}>
              <Box
                display="flex"
                alignItems="baseline"
                flexWrap="wrap"
                gap={{ base: 0, sm: 2 }}
              >
                <Text
                  fontWeight="medium"
                  fontSize="sm"
                  color="gray.500"
                  order={{ base: 0, sm: 1 }}
                  flexBasis={{ base: "100%", sm: "auto" }}
                >
                  En Proceso
                </Text>
                {isLoading ? (
                  <Skeleton height="28px" width="96px" />
                ) : (
                  <Stat.ValueText
                    fontSize={{ base: "xl", sm: "2xl" }}
                    fontWeight="bold"
                    color="gray.800"
                    letterSpacing="tight"
                  >
                    {balance ? formatCurrency(balance.pending) : "$0"}
                  </Stat.ValueText>
                )}
              </Box>
              <Stat.HelpText color="gray.500" mt={0} fontSize="xs">
                Pagos que están en proceso de revisión o aprobación
              </Stat.HelpText>
            </Stat.Root>
          </Box>
        </Card.Body>
      </Card.Root>
    </SimpleGrid>
  );
}
